import store from '@/store/'
import i18n from '@/locales'

export default [
  {
    path: '/benefits',
    name: 'benefits',
    component: () =>
      import(
        /* webpackChunkName: 'benefits-index' */ '@/modules/benefits/_views/Index'
      ),
    meta: { section: 'benefits' },
    redirect: to => {
      let currentCompany = store.getters['CompanyStore/currentCompany']

      let currentCompanyHasRetFlex =
        currentCompany && currentCompany.activatedFeatures
          ? currentCompany.activatedFeatures.find(
            el => el.feature.code === 'FLEXIBLE_REMUNERATION'
          )
          : false
      let currentCompanyHasSubvention =
        currentCompany && currentCompany.activatedFeatures
          ? currentCompany.activatedFeatures.find(
            el => el.feature.code === 'SUBVENTION_FEATURE'
          )
          : false
      if (currentCompanyHasRetFlex) {
        return '/benefits/users'
      }
      if (currentCompanyHasSubvention) {
        return '/benefits/social-benefits'
      }

      return '/dashboard'
    },

    // redirect: { name: 'benefits_users' },

    children: [
      {
        path: 'users',
        name: 'benefits_users',
        meta: {
          section: 'benefits',
          allowedRoles: ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_BOOKKEEPER']
        },
        component: () =>
          import(
            /* webpackChunkName: 'benefits-users' */ '@/modules/benefits/_views/users/UsersRetFlexIndex'
          ),
        beforeEnter (to, from, next) {
          let currentCompany = store.getters['CompanyStore/currentCompany']
          let currentCompanyHasRetFlex = currentCompany.activatedFeatures.find(
            el => el.feature.code === 'FLEXIBLE_REMUNERATION'
          )
          if (currentCompanyHasRetFlex) {
            next()
          } else {
            store.dispatch(
              'SnackBars/addError',
              i18n.t('office_feature_not_available')
            )
            next('/dashboard')
          }
        }
      },
      {
        path: 'social-benefits',
        name: 'social_benefits',
        meta: {
          section: 'benefits',
          allowedRoles: ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_BOOKKEEPER']
        },
        component: () =>
          import(
            /* webpackChunkName: 'social-benefits' */ '@/modules/benefits/_views/users/UsersSocialBenefitsIndex'
          ),
        beforeEnter (to, from, next) {
          let currentCompany = store.getters['CompanyStore/currentCompany']
          let currentCompanyHasSubvention = currentCompany.activatedFeatures.find(
            el => el.feature.code === 'SUBVENTION_FEATURE'
          )
          if (currentCompanyHasSubvention) {
            next()
          } else {
            store.dispatch(
              'SnackBars/addError',
              i18n.t('office_feature_not_available')
            )
            next('/dashboard')
          }
        }
      },
      {
        path: 'transactions',
        name: 'benefit_transactions',
        meta: {
          section: 'benefits',
          allowedRoles: ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_BOOKKEEPER']
        },
        component: () =>
          import(
            /* webpackChunkName: 'benefits-transactions' */ '@/modules/benefits/_views/transactions/TransactionsBenefitsIndex'
          )
      }
    ]
  }
]
